import normalizeTaxon from "../../utils/normalizations/normalize-taxon";
export default function getAllTaxonsOperation({ commerce  }) {
    async function getAllTaxons({ variables: getAllTaxonsVariables = {} , config: userConfig  } = {}) {
        //Uncomment the following line to debug
        /*     console.info(
      'getAllTaxons called. Configuration: ',
      'getAllProductsVariables: ',
      getAllTaxonsVariables,
      'config: ',
      userConfig
    ) */ const { page , parentSlug , include ="taxonomy,children,image,parent,parent.children"  } = getAllTaxonsVariables;
        const variables = {
            methodPath: "taxons.list",
            arguments: [
                {
                    include: include,
                    page: page,
                    per_page: 100,
                    ...parentSlug && {
                        "filter[parent_permalink]": parentSlug
                    }
                }, 
            ]
        };
        const config = commerce.getConfig(userConfig);
        const { fetch: apiFetch  } = config;
        const { data: spreeSuccessResponse  } = await apiFetch("__UNUSED__", {
            variables
        });
        const normalizedTaxons = spreeSuccessResponse.data.map((spreeTaxon)=>normalizeTaxon(spreeSuccessResponse, spreeTaxon));
        return {
            taxons: normalizedTaxons
        };
    }
    return getAllTaxons;
};
